import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify, useRedirect } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { TextInputIntrospected } from 'shared/react-admin/Inputs';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';
import { Company } from 'types/embedded/company';

export const CompaniesCreate = () => {
  const translate = useTypedTranslate();
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (company: Company) => {
    notify(
      <>
        Компания <TypographyBold text={company.name} /> создана
      </>,
      { type: 'success' },
    );
    redirect('list', Resources.Companies);
  };

  return (
    <CreateGuesserPage
      listName={translate('app.companies.titleText')}
      mutationOptions={{
        onSuccess,
        onError: () => undefined,
      }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" />,
      ]}
      title={translate('app.companies.createTitle')}
    >
      <Box py="24px" width="100%">
        <TextInputIntrospected
          fullWidth
          helperText={false}
          label={translate('app.table.name')}
          size="small"
          source="name"
          variant="outlined"
        />
      </Box>
    </CreateGuesserPage>
  );
};
